// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__G9dXy","navSearch":"Navbar_navSearch__8aN0p"};